import React, { useRef, useEffect } from 'react'
import PropTypes from 'prop-types'

function useOutsideWrapper(ref, setIsPanelOpen) {
  useEffect(() => {
    /**
     * Closes panel if clicked on outside
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsPanelOpen(false)
      }
    }

    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [ref, setIsPanelOpen])
}

function OutsideWrapper({ children, setIsPanelOpen }) {
  const wrapperRef = useRef(null)
  useOutsideWrapper(wrapperRef, setIsPanelOpen)

  return <div ref={wrapperRef}>{children}</div>
}

OutsideWrapper.propTypes = {
  children: PropTypes.element.isRequired,
  setIsPanelOpen: PropTypes.func.isRequired
}

export default OutsideWrapper
